import { render, staticRenderFns } from "./InvoiceApplicationList.vue?vue&type=template&id=54aa4950"
import script from "./InvoiceApplicationList.vue?vue&type=script&lang=js"
export * from "./InvoiceApplicationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports